import { render, staticRenderFns } from "./TestDetailsAP.vue?vue&type=template&id=19f6284e"
import script from "./TestDetailsAP.vue?vue&type=script&lang=js"
export * from "./TestDetailsAP.vue?vue&type=script&lang=js"
import style0 from "./TestDetailsAP.vue?vue&type=style&index=0&id=19f6284e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports